(function () {
  function closeTooltip(wrap) {
    if (!wrap) return;
    wrap.classList.remove('is-open');
    const trigger = wrap.querySelector('[data-product-fact-tooltip-trigger]');
    const panel = wrap.querySelector('[data-product-fact-tooltip-panel]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('hidden', '');
  }

  function closeAllTooltipsIn(container) {
    container.querySelectorAll('[data-product-fact-tooltip].is-open').forEach((w) => closeTooltip(w));
  }

  function initContainer(container) {
    if (container.dataset.productFactsInit) return;
    container.dataset.productFactsInit = 'true';

    container.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('[data-product-fact-tooltip-close]');
      if (closeBtn) {
        e.preventDefault();
        closeTooltip(closeBtn.closest('[data-product-fact-tooltip]'));
        return;
      }

      const trigger = e.target.closest('[data-product-fact-tooltip-trigger]');
      if (!trigger || !container.contains(trigger)) return;

      e.preventDefault();
      e.stopPropagation();

      const wrap = trigger.closest('[data-product-fact-tooltip]');
      const panel = wrap && wrap.querySelector('[data-product-fact-tooltip-panel]');
      if (!wrap || !panel) return;

      const wasOpen = wrap.classList.contains('is-open');
      closeAllTooltipsIn(container);

      if (!wasOpen) {
        wrap.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
        keepElementInViewport(panel);
      }
    });
  }

  function onDocumentClick(e) {
    if (e.target.closest('[data-product-fact-tooltip]')) return;
    document.querySelectorAll('[data-product-facts] [data-product-fact-tooltip].is-open').forEach((w) => closeTooltip(w));
  }

  function onEscape(e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-product-facts] [data-product-fact-tooltip].is-open').forEach((w) => closeTooltip(w));
  }

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('keydown', onEscape);

  document.querySelectorAll('[data-product-facts]').forEach(initContainer);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-product-facts]').forEach(initContainer);
  });

  function keepElementInViewport(element) {
    element.style.position = 'absolute';
    
    // 1. Get current element bounds relative to viewport
    const rect = element.getBoundingClientRect();
    
    // 2. Get viewport dimensions
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // 3. Check boundaries and calculate corrections
    let currentLeft = parseFloat(element.style.left) || element.offsetLeft;
    let currentTop = parseFloat(element.style.top) || element.offsetTop;

    // Right edge bleed
    if (rect.right > viewportWidth) {
      currentLeft -= (rect.right - viewportWidth);
    }
    // Left edge bleed
    if (rect.left < 0) {
      currentLeft += Math.abs(rect.left);
    }
    // Bottom edge bleed
    if (rect.bottom > viewportHeight) {
      currentTop -= (rect.bottom - viewportHeight);
    }
    // Top edge bleed
    if (rect.top < 0) {
      currentTop += Math.abs(rect.top);
    }

    // 4. Apply adjusted coordinates
    element.style.left = `${currentLeft + 12}px`;
    element.style.top = `${currentTop}px`;
  }
})();
